import {CircularProgress, TextField, Tooltip} from "@mui/material";
import {useCallback, useEffect, useRef, useState} from "react";
import debounce from "lodash.debounce";
import stickyNoteService from "../../services/StickyNoteService";
import {Check, VisibilityOff, Warning} from "@mui/icons-material";

function StickyNotes(props) {
    const [stickyNote, setStickyNote] = useState(null);
    const [tempText, setTempText] = useState("");
    const [state, setState] = useState(null);
    const [showTick, setShowTick] = useState(false);
    const [isHovered, setIsHovered] = useState(false); // New state for hover tracking
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (stickyNote) return;
        stickyNoteService.findNoteOfCurrentUser()
            .then(response => {
                setStickyNote(response);
                setTempText(response?.noteText || "");
            })
            .catch(error => console.error(error));
    }, [stickyNote]);

    const saveNote = useCallback(debounce((text) => {
        setState("SAVING");
        stickyNoteService.upsertStickyNote({noteText: text})
            .then(response => {
                setStickyNote(response);
                setTimeout(() => setState("SAVED"), 1000);
            })
            .catch(error => console.error(error));
    }, 1500), []);

    const onChange = (e) => {
        const newValue = e.target.value;
        setTempText(newValue);
        setState("UNSAVED");
        setShowTick(true);
        if (stickyNote?.noteText !== newValue) {
            saveNote(newValue);
        }
    };

    useEffect(() => {
        if (state !== "SAVED") return;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setShowTick(false), 3000);
        return () => clearTimeout(timeoutRef.current);
    }, [state]);

    return (
        <div
            style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
                backgroundColor: "#FFFFC5",
                padding: "5px",
                boxShadow: "3px 3px 10px black",
                zIndex: 1000
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <TextField
                multiline
                minRows={5}
                maxRows={20}
                placeholder="Jegyzet hozzáadása..."
                variant="standard"
                onChange={onChange}
                value={tempText}
                spellCheck={false}
                sx={{
                    '& .MuiInputBase-root': {
                        lineHeight: "1.2",
                    },
                    '& .MuiInputBase-root:before': {
                        borderBottom: 'none !important',
                    },
                    '& .MuiInputBase-root:after': {
                        borderBottom: 'none !important',
                    },
                    width: "320px",
                }}
            />
            {isHovered && (
                <div
                    style={{
                        position: "absolute",
                        top: "0px",
                        right: "5px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "bold"
                    }}
                    onClick={() => props.toggleStickNoteState()}
                >
                    <Tooltip title={"Elrejtés"} placement="top">
                        <VisibilityOff sx={{color: "gray"}}/>
                    </Tooltip>
                </div>
            )}
            {showTick && (
                <div style={{position: "absolute", right: "0px", bottom: "0px", zIndex: "0"}}>
                    {(() => {
                        switch (state) {
                            case "UNSAVED":
                                return <Warning sx={{color: "orange", padding: "0px", margin: "0px 5px -5px 0px"}}/>;
                            case "SAVED":
                                return <Check sx={{color: "green", padding: "0px", margin: "0px 5px -5px 0px"}}/>;
                            case "SAVING":
                                return <CircularProgress size={16} sx={{margin: "0px 9px -1px 0px"}}/>;
                            default:
                                return null;
                        }
                    })()}
                </div>
            )}
        </div>
    );
}

export default StickyNotes;
